import React, { Component } from "react";
import Navbar from "../../components/Navbar.js";
import {
  format_date,
  GET,
  loading,
} from "../../components/CustomComponent.js";
import Pagination from "@mui/material/Pagination";
import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css";

// ★ เดิมหน้านี้เป็น template (เรียก api/transaction/* ที่ไม่มีจริง, หัวข้อ "ทดสอบ", ปุ่มเพิ่ม/แก้/ลบปลอม)
//   ต่อกับ GET /api/admin/logs/list (modules/user-log) — API รองรับแค่ data_search + page/page_size
//   และเป็นข้อมูลอ่านอย่างเดียว จึงตัดปุ่มเพิ่ม/แก้ไข/ลบ, ตัวกรองวันที่/สถานะที่ API ไม่รองรับออก
const PAGE_SIZE = 10;

export default class Logs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      count: 0,
      page: 1,
      data: [],
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }

  Get = async (page) => {
    loading(true);
    let body = {
      page: page,
      page_size: PAGE_SIZE,
      data_search: this.state.search,
    };
    let result = await GET("api/admin/logs/list", body, true);
    if (result?.status) {
      this.setState({ data: result.data || [], count: result.count || 0, page });
    }
    loading(false);
  };

  render() {
    return (
      <div className="w-100 min-vh-100">
        <Navbar header="Logs" page1="หน้าหลัก" page2="ประวัติการใช้งานระบบ" />
        <div className="body px-3 pb-3 pt-0">
          <h4 className="fw-bold mb-2">ประวัติการใช้งานระบบ</h4>
          <div className="d-flex align-items-center flex-wrap">
            <input
              type="text"
              className="form-control wpx-250 me-2 mb-2"
              placeholder="โครงการ, ชื่อผู้ใช้, ประเภทการทำงาน"
              onChange={(e) => {
                this.setState({ search: e.target.value });
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") this.Get(1);
              }}
              value={this.state.search}
            />
            <div className="d-flex">
              <button
                className="btn btn-success px-4 me-2 mb-2"
                onClick={() => {
                  this.Get(1);
                }}
              >
                ค้นหา
              </button>
              <button
                className="btn btn-outline-success px-4 me-2 mb-2"
                onClick={() => {
                  window.location.reload();
                }}
              >
                ล้างค่า
              </button>
            </div>
          </div>
          <div className="card rounded border-0 overflow-hidden">
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead className="bg-light text-secondary">
                  <tr>
                    <th className="wpx-50 text-center">ลำดับ</th>
                    <th className="text-nowrap">วันที่/เวลา</th>
                    <th className="text-nowrap">โครงการ</th>
                    <th className="text-nowrap">ชื่อผู้ใช้</th>
                    <th className="text-nowrap">ชื่อ - นามสกุล</th>
                    <th className="text-nowrap">ประเภทการทำงาน</th>
                    <th className="text-nowrap">รายการ</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.data?.length === 0 && (
                    <tr>
                      <td colSpan={7} className="text-center text-secondary">
                        ไม่พบข้อมูล
                      </td>
                    </tr>
                  )}
                  {this.state.data?.map((item, index) => (
                    <tr key={"table_" + index}>
                      <td className="text-center">
                        {(this.state.page - 1) * PAGE_SIZE + index + 1}
                      </td>
                      <td className="text-nowrap">
                        {item.createdAt ? format_date(item.createdAt, "dd/mm/yyyy hh:mm") : "-"}
                      </td>
                      <td>{item.project_name || "-"}</td>
                      <td>{item.username || "-"}</td>
                      <td>{item.full_name || "-"}</td>
                      <td>{item.action_type || "-"}</td>
                      <td>{item.action_target || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-between p-3">
            <small>ทั้งหมด {this.state.count} รายการ</small>
            <Pagination
              count={Math.ceil(this.state.count / PAGE_SIZE)}
              page={this.state.page}
              showFirstButton
              showLastButton
              onChange={(_, page) => {
                this.Get(page);
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}
